import { HTTP_METHOD } from 'constants/http';

export const PENDING_CHANGES_OPERATION_HEADER = 'X-Skynet-Pending-Changes-Operation';

export const WRITE_METHODS = [
  HTTP_METHOD.POST,
  HTTP_METHOD.PUT,
  HTTP_METHOD.PATCH,
  HTTP_METHOD.DELETE,
];
